import React from "react";
import { IconProps } from "../type";

export const StoreIcon=({ width, height, color,className }: IconProps)=> {
  return (
   <svg
   xmlns="http://www.w3.org/2000/svg"
   width={width ? width : "18"}
    height={height ? height : "19"}
    fill="none"
    className={className}
   viewBox="0 0 18 19"
 >
   <path
      stroke={color ? color :"#000"}
     strokeWidth="1.2"
     d="M13 5a4 4 0 00-8 0m8 3a4 4 0 01-8 0M1 5h16v11a2 2 0 01-2 2H3a2 2 0 01-2-2V5z"
   ></path>
 </svg>
    
   
  );
}

export default StoreIcon


